import * as React from 'react';

import { Box, Skeleton } from '@mui/material';
import { Sizes } from '../../@shared/palette';
import { FlexBoxColumn, FlexBoxInline } from '../../@shared/templates';


const SchemaModelsShimmer = () => {

  return <Box sx={{ ...FlexBoxColumn, gap: 0, marginTop: "5px" }}>
    <Box sx={{ ...FlexBoxColumn, gap: 0, padding: "16px 8px" }}>
      <Skeleton variant="text" width={250} sx={{ fontSize: Sizes.textPrimary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Box sx={FlexBoxInline}>
        <Skeleton variant="rectangular" width={50} height={20} />
        <Skeleton variant="rectangular" width={60} height={20} />
        <Skeleton variant="rectangular" width={70} height={20} />

      </Box>
    </Box>
    <Box sx={{ ...FlexBoxColumn, gap: 0, padding: "16px 8px" }}>
      <Skeleton variant="text" width={250} sx={{ fontSize: Sizes.textPrimary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Box sx={FlexBoxInline}>
        <Skeleton variant="rectangular" width={50} height={20} />
        <Skeleton variant="rectangular" width={60} height={20} />
        <Skeleton variant="rectangular" width={70} height={20} />

      </Box>
    </Box>
    <Box sx={{ ...FlexBoxColumn, gap: 0, padding: "16px 8px" }}>
      <Skeleton variant="text" width={250} sx={{ fontSize: Sizes.textPrimary, marginBottom: "5px" }} />
      <Skeleton variant="text" width={150} sx={{ fontSize: Sizes.textSecondary, marginBottom: "5px" }} />
      <Box sx={FlexBoxInline}>
        <Skeleton variant="rectangular" width={50} height={20} />
        <Skeleton variant="rectangular" width={60} height={20} />
        <Skeleton variant="rectangular" width={70} height={20} />

      </Box>
    </Box>
  </Box>


}

export default SchemaModelsShimmer;
